import { ServerAction } from "../../../api/dtos/server/ServerAction";
import { CLEAR_CACHE } from "../types";
import { API_SERVER_ACTION_UPDATED, API_SERVER_ADDED, API_SERVER_DEPLOYED, API_SERVER_LOADED, API_SERVER_REMOVED, API_SERVERS_ACTION_UPDATED, API_SERVERS_CARD_LOADED, API_SERVERS_LOADED, ServerActionTypes, ServerState } from "./types";

const InitialState: ServerState = {
    server: {
        id: 0,
        domainName: '',
        runnerName: 'string',
        sshUser: 'string',
        sshPrivateKey: 'string',
        deployScript: 'string',
        isStarted: false
    },
    servers: [],
    serversCards: [],
    isLoaded: false,
};

export default function ServerReducer(state: ServerState = InitialState, action: ServerActionTypes): ServerState {

    switch (action.type) {
        case API_SERVERS_LOADED:
            return {
                ...state,
                servers: action.servers,
                isLoaded: true
            };
        case API_SERVER_LOADED:
            return {
                ...state,
                server: action.server
            };
        case API_SERVER_ADDED:
            return {
                ...state,
                server: action.server
            };
        case API_SERVER_REMOVED:
            return {
                ...state,
                servers: state.servers.filter(server => server.id !== action.serverId)
            };
        case API_SERVER_DEPLOYED:
            return {
                ...state
            };
        case API_SERVER_ACTION_UPDATED:
            const updatedServers = state.servers.map(server =>
                server.id === action.serverId
                    ? { ...server, isStarted: action.isStarted.action === ServerAction.Start }
                    : server
            );
            return {
                ...state,
                servers: updatedServers
            };
        case API_SERVERS_ACTION_UPDATED:
            return {
                ...state,
                servers: state.servers.map(server => ({
                    ...server,
                    isStarted: action.isStarted.action === ServerAction.Start,
                }))
            };
        case API_SERVERS_CARD_LOADED:
            return {
                ...state,
                serversCards: action.serversCards,
            };
        case CLEAR_CACHE:
            return InitialState;
        default:
            return state;
    }
}